import React from 'react'
import { Outlet } from 'react-router-dom'

import Footer from '../components/footer'
import Header from '../components/header'

function HomeLayout() {
  return (
    <div className="flex flex-col min-h-[100dvh]">
      {/* Header */}
      <Header />

      {/* Main content fills available space */}
      <main className="flex-1">
        <Outlet />
      </main>

      {/* Footer always sticks to the bottom */}
      <Footer />
    </div>
  )
}

export default HomeLayout
